const spdata2020 = [
  {
    Roll: "15BEC010",
    Name: "Aditya r gupta",
    Company: "Silver touch technologies",
  },
  {
    Roll: "15BEC017",
    Name: "Anisha unnithan",
    Company: "Energo entel",
  },
  {
    Roll: "15BEC031",
    Name: "Dhruv panchal",
    Company: "Rf microtech,  vadodra ",
  },
  {
    Roll: "15BEC085",
    Name: "Prajapati yamini bhupendrabhai",
    Company: "Hems and hubs software company",
  },
  { Roll: "15BEC124", Name: "Vijekar tirth hemant", Company: "Inhouse" },
  {
    Roll: "15BEC156",
    Name: "Vikas a panchal",
    Company: "Sigma trainers and kits",
  },
  { Roll: "15BEC166", Name: "Jay sapra", Company: "Sigma trainers and kits" },
  {
    Roll: "15BEC181",
    Name: "Shah milap jayeshkumar",
    Company: "X way elevators",
  },
  {
    Roll: "16BEC001",
    Name: "Aayushmaan mazoomdar",
    Company: "Ongc hazira plant, surat",
  },
  {
    Roll: "16BEC002",
    Name: "Maniar aayushi nirav ",
    Company: "Smart controls pvt. ltd.",
  },
  {
    Roll: "16BEC004",
    Name: "Abhishek  paliwal",
    Company: " johnson controls- hitachi air conditioning limited",
  },
  {
    Roll: "16BEC005",
    Name: "Abhishek  soni",
    Company: "National high speed rail corporation ltd",
  },
  {
    Roll: "16BEC006",
    Name: "Bajpai adhyan anil",
    Company: "ONGC",
  },
  {
    Roll: "16BEC007",
    Name: "Parth sinha",
    Company: "ONGC",
  },
  {
    Roll: "16BEC008",
    Name: "Aditi  bhatnagar",
    Company: "Smart controls pvt. ltd.",
  },
  { Roll: "16BEC009", Name: "Agravat mayur rajeshkumar", Company: "Inhouse" },
  {
    Roll: "16BEC010",
    Name: "Agrawal shikha hitesh",
    Company: "ONGC",
  },
  {
    Roll: "16BEC011",
    Name: "Ambasana kaushal shishirbhai",
    Company: "Nkonnect infoway",
  },
  { Roll: "16BEC012", Name: "Arpit  tiwary", Company: "Bsnl office ahmedabad" },
  { Roll: "16BEC013", Name: "Ronal khara", Company: "Western railways " },
  {
    Roll: "16BEC014",
    Name: "Poorva  gupta",
    Company: "Arden teleservices llp",
  },
  { Roll: "16BEC015", Name: "Avantika  sharma", Company: "Inovadd automation" },
  {
    Roll: "16BEC016",
    Name: "Babiya meet kishor",
    Company: "Silver touch technologies",
  },
  {
    Roll: "16BEC017",
    Name: "Prajapati ajaykumar vinaykumar",
    Company: "Inhouse",
  },
  {
    Roll: "16BEC019",
    Name: "Prakhar   suneja",
    Company: "Silver touch technologies",
  },
  {
    Roll: "16BEC020",
    Name: "Pranjal  shrivastava",
    Company: "Smart controls pvt. ltd.",
  },
  {
    Roll: "16BEC021",
    Name: "Bodhanwala krishna kalpeshkumar",
    Company: "The techno valley",
  },
  { Roll: "16BEC022", Name: "Prateek kamal gyanchandani", Company: "ONGC" },
  { Roll: "16BEC023", Name: "Ms. chanchal   soni", Company: "ONGC" },
  { Roll: "16BEC026", Name: "Rakshit  goyal", Company: "Birla cement works" },
  {
    Roll: "16BEC027",
    Name: "Fulja oza ",
    Company: "Reliance jio infocom ltd.",
  },
  {
    Roll: "16BEC028",
    Name: "Ravi  mistry",
    Company: "Oil and natural gas corporation",
  },
  {
    Roll: "16BEC029",
    Name: "Sangtani darshan jagdish ",
    Company: "Tcs/nutron",
  },
  {
    Roll: "16BEC030",
    Name: "Reshma  kandula",
    Company: "Jsw steel coated products ltd",
  },
  {
    Roll: "16BEC031",
    Name: "Desai dhwani hetalbhai",
    Company: "Microlink solutions pvt. ltd",
  },
  { Roll: "16BEC032", Name: "Desai vinay atulbhai", Company: "ONGC" },
  { Roll: "16BEC033", Name: "Sinha devanshi  sanjeev  ", Company: "Iocl" },
  {
    Roll: "16BEC034",
    Name: "Sarthak  seth",
    Company: "Indian telephone industry",
  },
  {
    Roll: "16BEC035",
    Name: "Dhruv  mathur",
    Company: "Pyrotech electronics pvt ldt",
  },
  {
    Roll: "16BEC036",
    Name: "Saumya thacker",
    Company: "Eximius design (pvt) ltd",
  },
  {
    Roll: "16BEC037",
    Name: "Divyanshu  tak",
    Company: "Udaipur solar obeservatory",
  },
  { Roll: "16BEC038", Name: "Shashank khemka", Company: "Soham erp/vodafone" },
  { Roll: "16BEC039", Name: "Thakkar hardi bhargavbhai ", Company: "Ongc" },
  {
    Roll: "16BEC040",
    Name: "Shivang  dalal",
    Company: "Digivalet inc. (paragon business solutions limited, indore)",
  },
  { Roll: "16BEC041", Name: "Heli sanjay kolambekar", Company: "Energo entel" },
  {
    Roll: "16BEC042",
    Name: "Shivani patel",
    Company: "Oizom instruments pvt ltd",
  },
  { Roll: "16BEC044", Name: "Herin shah", Company: "Royal technosoft pvt ltd" },
  { Roll: "16BEC045", Name: "Shreejita chaudhuri", Company: "ONGC" },
  {
    Roll: "16BEC046",
    Name: "Ishan  lakhwani",
    Company: "Railways, drm office",
  },
  {
    Roll: "16BEC047",
    Name: "Shreya  adhikari",
    Company: "Lipidata systems ltd.",
  },
  {
    Roll: "16BEC048",
    Name: "Ms. ishita  kumawat",
    Company: "Lipidata systems ltd.",
  },
  { Roll: "16BEC049", Name: "Shreyansh  nayak", Company: "Bsnl" },
  { Roll: "16BEC051", Name: "Shreyansh  surana", Company: "Wehear" },
  { Roll: "16BEC052", Name: "Jahnvi bedia", Company: "ONGC" },
  { Roll: "16BEC053", Name: "Simran  kathuria", Company: "ONGC" },
  { Roll: "16BEC054", Name: "Jainam  lakhtaria", Company: "Inhouse" },
  { Roll: "16BEC055", Name: "Somil  kabra", Company: "Nitin spinners ltd" },
  { Roll: "16BEC056", Name: "Jaya  thadhani", Company: "Bsnl" },
  { Roll: "16BEC057", Name: "Sujaan  dubey", Company: "ONGC" },
  {
    Roll: "16BEC058",
    Name: "Jayvik desai",
    Company: "Smart controls pvt. ltd.",
  },
  { Roll: "16BEC059", Name: "Swastika  dash", Company: "ONGC" },
  { Roll: "16BEC060", Name: "Saket lunker", Company: "Jain metals" },
  {
    Roll: "16BEC062",
    Name: "Jethva monil jayeshbhai",
    Company: "Airport authority of india ",
  },
  {
    Roll: "16BEC063",
    Name: "Jethwa himang kishorbhai",
    Company: "Genus electrotech ",
  },
  {
    Roll: "16BEC064",
    Name: "Uttkarsh dinesh tak",
    Company: "Episodic labs pvt. ltd.",
  },
  { Roll: "16BEC065", Name: "Jobanputra ami", Company: "Rf microtech" },
  {
    Roll: "16BEC066",
    Name: "Vakharia anshul rajan",
    Company: "Prasad koch-technik pvt. ltd.",
  },
  {
    Roll: "16BEC067",
    Name: "Kadia harshil vinodkumar",
    Company: "Apex automation pvt. ltd.",
  },
  {
    Roll: "16BEC068",
    Name: "Vatsal  sompura",
    Company: "Rswm ltd. rishabhdev unit",
  },
  {
    Roll: "16BEC069",
    Name: "Kanojiya manavkumar mahendrabhai",
    Company: "Alidhra electronics industries",
  },
  {
    Roll: "16BEC070",
    Name: "Vidhi shah",
    Company: "Silver touch technologies",
  },
  {
    Roll: "16BEC071",
    Name: "Karan bhavesh shah",
    Company: "Enercomp solutions pvt. ltd.",
  },
  {
    Roll: "16BEC072",
    Name: "Vikani purval kishorbhai",
    Company: "(n)code solutions gnfc ltd.",
  },
  { Roll: "16BEC073", Name: "Karan shah", Company: "Abaj interiors pvt. ltd." },
  {
    Roll: "16BEC074",
    Name: "Karnik  gupta",
    Company: "Ashitech equipments pvt ltd.",
  },
  { Roll: "16BEC075", Name: "Yash lad", Company: "Swift auxi technik pvt ltd" },
  {
    Roll: "16BEC076",
    Name: "Naman khandelwal",
    Company: "Silver touch technologies",
  },
  {
    Roll: "16BEC077",
    Name: "Priti khandelwal",
    Company: "Mentor graphics pvt. ltd.",
  },
  {
    Roll: "16BEC079",
    Name: "Keshavkant sharma",
    Company: "Enercomp solutions pvt. ltd.",
  },
  {
    Roll: "16BEC080",
    Name: "Yogesh  maheshwari",
    Company: "A b technical services pvt. ltd.",
  },
  {
    Roll: "16BEC081",
    Name: "Kuhuk narain",
    Company: "Mentor graphics pvt. ltd.",
  },
  {
    Roll: "16BEC082",
    Name: "Mahesh chandak",
    Company: "Semitronik industries",
  },
  {
    Roll: "16BEC083",
    Name: "Makwana mehul pravinbhai",
    Company: "Nitsan technology pvt. ltd.",
  },
  {
    Roll: "16BEC084",
    Name: "Makwana shreeya kiritbhai",
    Company: "Silver touch technologies",
  },
  {
    Roll: "16BEC085",
    Name: "Punit  malpani",
    Company: "A b technical services pvt. ltd.",
  },
  {
    Roll: "16BEC086",
    Name: "Maru kapilkumar parbatbhai",
    Company: "Arise infoway pvt. ltd.",
  },
  {
    Roll: "16BEC087",
    Name: "Mehta meet kirankumar",
    Company: "A b technical services pvt. ltd.",
  },
  {
    Roll: "16BEC088",
    Name: "Mishra saurabh sushil",
    Company: "Silver touch technologies",
  },
  {
    Roll: "16BEC090",
    Name: "Miti shah",
    Company: "Prudent technoserve pvt. ltd",
  },
  {
    Roll: "16BEC091",
    Name: "Modasiya mohmed safin mohmed yusuf",
    Company: "Power tech solutions pvt. ltd",
  },
  {
    Roll: "16BEC092",
    Name: "Modi parth ketankumar",
    Company: "A b technical services pvt. ltd.",
  },
  {
    Roll: "16BEC093",
    Name: "Mohamad abrar i mansuri",
    Company: "Power tech solutions pvt. ltd",
  },
  {
    Roll: "16BEC094",
    Name: "Muskan  porwal",
    Company: "A b technical services pvt. ltd.",
  },
  {
    Roll: "16BEC095",
    Name: "Naman  goyal",
    Company: "Power tech solutions pvt. ltd",
  },
  {
    Roll: "16BEC096",
    Name: "Nitesh  kalwani",
    Company: "Nielit (ministry of electronics and it) govt.of india",
  },
  {
    Roll: "16BEC097",
    Name: "Onima pandit",
    Company: "Cadence design systems india pvt. ltd.",
  },
  { Roll: "16BEC098", Name: "Oshin  bansal", Company: "Glowlogic media" },
  {
    Roll: "16BEC099",
    Name: "Oza vatsal",
    Company: "In house src blockchain project",
  },
  {
    Roll: "16BEC100",
    Name: "Pandya shiven hiteshbhai",
    Company: "In house src   ",
  },
  {
    Roll: "16BEC101",
    Name: "Rahul bansal",
    Company: "Silver touch technologies",
  },
  { Roll: "16BEC102", Name: null, Company: "Silver touch technology limdt." },
  { Roll: "16BEC102", Name: "Ayush jain", Company: "In house robocon" },
  {
    Roll: "16BEC103",
    Name: "Stuti v garg",
    Company: "Enercomp solutions pvt. ltd.",
  },
  {
    Roll: "16BEC104",
    Name: "Sparsh yashlaha",
    Company: "A b technical services pvt. ltd.",
  },
  {
    Roll: "16BEC105",
    Name: "Arya pranjal vedruchibhai",
    Company: "ONGC",
  },
  {
    Roll: "16BEC106",
    Name: "Issrani muskan darshan kumar",
    Company: "Maxgen technologies",
  },
  { Roll: "16BEC107", Name: "Amin prerak ashish", Company: 'other' },
  {
    Roll: "16BEC108",
    Name: "Meet m patel",
    Company: "Abaj interiors pvt. ltd.",
  },
  {
    Roll: "16BEC109",
    Name: "Anmol jain",
    Company: "Vayve technologies private limited",
  },
  {
    Roll: "16BEC110",
    Name: "Patel rutvik bipinchandra",
    Company: "A&d technology  pvt. ltd.",
  },
  {
    Roll: "16BEC111",
    Name: "Utkarsh sunil agrawal",
    Company: "Coral blockchain",
  },
  {
    Roll: "16BEC112",
    Name: "Gursimar hora",
    Company: "Abaj interiors pvt. ltd.",
  },
  { Roll: "16BEC113", Name: "Kamya ahuja", Company: "Softvan" },
  {
    Roll: "16BEC115",
    Name: "Rinali dipenbhai shah",
    Company: "Relytree technologies pvt. ltd.",
  },
  { Roll: "16BEC116", Name: "Vithika mandhwani", Company: "Softvan" },
  {
    Roll: "16BEC117",
    Name: "Mengar ronak deepakbhai",
    Company: "S.b.i ind. pvt. ltd.",
  },
  { Roll: "16BEC118", Name: "Ramnani vinita jagdish", Company: "L&t" },
  {
    Roll: "16BEC119",
    Name: "Patel nishith nileshkumar",
    Company: "Lunar electronics",
  },
  {
    Roll: "16BEC120",
    Name: "Patel meet manojkumar",
    Company: "Lunar electronics",
  },
  {
    Roll: "16BEC121",
    Name: "Amipara parth rameshbhai",
    Company: "Lunar electronics",
  },
  { Roll: "16BEC122", Name: "Talwar vivek jayant", Company: "Iim indore" },
  { Roll: "16BEC123", Name: "Nitin sharma", Company: "Microtech systems" },
  {
    Roll: "16BEC124",
    Name: "Bhatt mauli sanjaykumar",
    Company: "Silver touch technologies",
  },
  { Roll: "16BEC125", Name: "Akhilesh sivadasan", Company: "G.e. pvt ltd" },
  { Roll: "16BEC126", Name: "Devika muley", Company: "Maxgen technologies" },
  {
    Roll: "16BEC127",
    Name: "Bharat aasija",
    Company: "Premier electronics services",
  },
  {
    Roll: "16BEC129",
    Name: "Candy brendon james",
    Company: "Power tech solutions pvt. ltd",
  },
  {
    Roll: "16BEC130",
    Name: "Pancholi mrunal nileshkumar",
    Company: "Microtech systems",
  },
  {
    Roll: "16BEC160",
    Name: "Nayak laksh harshad",
    Company: "Premier electronics services",
  },
  {
    Roll: "16BEC162",
    Name: "Panchal bhoomit",
    Company: "Swift auxi technik pvt. ltd.",
  },
  { Roll: "16BEC174", Name: "Karan saluja", Company: "ONGC" },
  {
    Roll: "16BEC177",
    Name: "Solanki mehulkumar ishvarbhai",
    Company: "ONGC",
  },
  { Roll: "16BEC178", Name: "Ronak sumbhe", Company: "Glowlogic media" },
  {
    Roll: "16BEC181",
    Name: "Vaniya hardik bhanuprasad",
    Company: "ONGC",
  },
];


export default spdata2020;